import { Injectable } from '@angular/core';
import { ICoreInfo, IUserInfo, ISystem, IRepInfo, IAgencyInfo, IBranchInfo, IUserProfile } from '../interface';
import { HttpClient } from '@angular/common/http';
import { ApplicationService } from './application.service';

@Injectable({ providedIn: 'root' })
export class UserService {

  userInfo: UserInfo;
  result: string;
  loginResponse = null;
  enterOtp = "";
  continue = false;
  accept = true;
  doLogin = true;

  constructor(private http: HttpClient) {

  }

  agree() {
    this.accept = true;
  }

  disagree() {
    window.location.href = '/';
  }

  login(service: any, username: string, password: string, sendOtp: boolean) {
    if (this.doLogin) {
      this.doLogin = false;
      this.result = "";
      this.http.post<any>(service.apiServiceUrl + '/User/Login', { Username: username, Password: password })
        .toPromise().then(response => {
          this.doLogin = true;
          if (response.Continue) {
            service.createApplicationLog("Function", "Login", username);
            this.loginResponse = response;
            localStorage.setItem("FilrCipher", this.loginResponse.Cipher);

            if ((service.applicationMode == 3) && !service.isLocal && sendOtp) {
              this.sendOTP(service, username);
            }
            else {
              if (service.applicationMode == 4 && password.toLowerCase().indexOf("tmp_") > -1) {
                sessionStorage.setItem("reset_password", "reset_password");
              }
              this.loadProfile(service, username);
            }
          }
          else {
            this.result = response.access_token;
          }
        });
    }
    
  }

  sendOTP(service: any, username: string) {
    this.http.get<any>(service.apiServiceUrl + '/User/SendOtp?repNumber=' + username + "&type=2")
      .toPromise().then(response => {
        if (response.Result) {
          this.enterOtp = response.Message;
        }
      });
  }

  loadProfile(service: any, username: string) {

    sessionStorage.setItem("avbobJWT", this.loginResponse.access_token);
    sessionStorage.setItem("avbobJWTRefresh", this.loginResponse.refresh_token);
    sessionStorage.setItem("avbobCipher", this.loginResponse.Cipher);
    localStorage.setItem("integrationJWT", this.loginResponse.access_token);
    
    sessionStorage.setItem("username", username);
    
    this.continue = true;
    service.loadUserProfile();
    service.profileText = "LOADING YOUR PROFILE...";

  }


}



export class UserInfo implements IUserInfo {
  Username: string;
  DisplayName: string;
  IsAuthenticated: boolean;
  Initials: string;
  Surname: string;
  IdentityNumber: string;
  EmailAddress: string;
  EmployeeNumber: string;
  Systems: ISystem[];
  CoreInfo: ICoreInfo;
  RepInfo: IRepInfo;
  AgencyInfo: IAgencyInfo;
  BranchInfo: IBranchInfo;
  Profile: IUserProfile;
  CellNumber: string;
  Role: string;
  SubAgentNo: string;
  IdNumberHash: string;
}

